import axios from './config';

export const forgotPassword = data => {
  return axios.post('/auth/forgot', data).then(res => res.data);
};

export const loginRequest = (email, password) => {
  return axios.post('/auth/login', { email, password });
};

export const logoutRequest = () => {
  return axios.get('/auth/logout');
};

export const signupRequest = (email, password) => {
  return axios.post('/auth/signup', { email, password });
};

export const facebookLoginRequest = data => {
  return axios.post('/auth/facebook', data);
};

export const googleLoginRequest = data => {
  return axios.post('/auth/google', data);
};

export const recoverCredentials = data => {
  return axios.post('/auth/update', data).then(res => res.data);
};
